import React from 'react';
import { useLocation } from 'react-router-dom';

export default function Footer() {
  const { pathname } = useLocation();

  // Home page is full-screen fixed layout — footer doesn't apply
  if (pathname === '/') return null;

  const year = new Date().getFullYear();

  return (
    <footer style={{
      borderTop: '1px solid var(--rule)',
      padding: '1.5rem 3rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '0.5rem',
    }}>
      <span style={{  fontSize: '11px', fontWeight: 300, color: 'var(--ink-faint)', letterSpacing: '0.04em' }}>
        © {year} Liam Boyd Creative Studio
      </span>
      <span style={{  fontSize: '11px', fontWeight: 300, color: 'var(--ink-faint)', letterSpacing: '0.04em' }}>
        Designed and built by Liam Boyd
      </span>
    </footer>
  );
}
